// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"053358cc","290":"d001754f","379":"6984dfa1"}[chunkId] + ".chunk.js";
};